import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirección permanente a la ruta limpia del Análisis Completo.
export const Route = createFileRoute("/herramientas/termometro")({
  beforeLoad: () => {
    throw redirect({ to: "/detector-de-fugas", statusCode: 301 });
  },
});
